import { useTranslations } from 'next-intl'

import { useParkingTypeMap } from '@/entities/room'
import { ContentBox } from '@/shared/ui'

import { Props } from './index.pc'
import { Heading, Item, Label, List, Value } from '../../common'

export const MobileFacilities = ({
  hasElevator,
  parkingType,
  parkingNotice,
}: Props) => {
  const t = useTranslations('room_detail')
  const { PARKING_TYPE_MAP } = useParkingTypeMap()

  return (
    <section className="space-y-4">
      <div className="space-y-4">
        <Heading size="small">{t('elevator_parking.title')}</Heading>
        <List spacing="small" className="typo-body2 text-gray-900">
          <Item className="justify-between">
            <Label icon="elevator" className="font-semibold">
              {t('elevator_parking.elevator')}
            </Label>
            <Value>
              {hasElevator
                ? t('elevator.type.available')
                : t('elevator.type.not_available')}
            </Value>
          </Item>
          <Item className="justify-between">
            <Label icon="parking" className="font-semibold">
              {t('elevator_parking.parking')}
            </Label>
            <Value>{PARKING_TYPE_MAP[parkingType]}</Value>
          </Item>
        </List>
      </div>

      {parkingNotice && (
        <ContentBox
          spacing="medium"
          color="light-gray"
          className="space-y-2 pb-5"
        >
          <h4 className="typo-label1 font-semibold text-gray-900">
            {t('parking.info.title')}
          </h4>
          <div className="typo-label2 font-normal whitespace-break-spaces text-gray-500">
            {parkingNotice}
          </div>
        </ContentBox>
      )}
    </section>
  )
}
